class CollapsibleElement extends HTMLElement {
  constructor() {
    super();
    this.disableExpandibleButton();
  }

  /**
   * disable expandible button in footer.liquid, on tablet & desktop
   */
  disableExpandibleButton() {
    const buttonHTMLElement = this.querySelector('.button--collapsible');
    const expandOnTabletDesktopHTMLElement = buttonHTMLElement?.closest(
      '.js-expand-on-tablet-desktop'
    );
    const breakpoint = getComputedStyle(document.documentElement)
      .getPropertyValue(`--breakpoint-md`)
      .trim();

    if (expandOnTabletDesktopHTMLElement) {
      // on load, tablet & desktop
      if (window.matchMedia(`(min-width: ${breakpoint})`).matches) {
        buttonHTMLElement?.setAttribute('disabled', 'disabled');
      }

      // on resize, tablet & desktop
      window.addEventListener('resize', () => {
        if (window.matchMedia(`(min-width: ${breakpoint})`).matches) {
          buttonHTMLElement?.setAttribute('disabled', 'disabled');
        } else {
          buttonHTMLElement?.removeAttribute('disabled');
        }
      });
    }
  }

  connectedCallback() {
    this.controller = this.querySelector('[aria-expanded]');
    this.controller.addEventListener('click', this.toggle.bind(this));
  }

  /**
   * find the content element
   */
  findContent() {
    const id = this.controller.getAttribute('aria-controls');
    this.content = document.getElementById(id);
  }

  /**
   * Open the collapsible element
   */
  open() {
    this.findContent();
    this.controller.setAttribute('aria-expanded', 'true');
    this.content.setAttribute('aria-hidden', 'false');
  }

  /**
   * Close the collapsible element
   */
  close() {
    this.findContent();
    this.controller.setAttribute('aria-expanded', 'false');
    this.content.setAttribute('aria-hidden', 'true');
  }

  /**
   * Toggle the collapsible element
   */
  toggle() {
    const isExpanded = this.controller.getAttribute('aria-expanded') === 'true';
    isExpanded ? this.close() : this.open();
  }
}

customElements.define('collapsible-element', CollapsibleElement);
